import InputField from "../../InputField/InputField";
import { useFindOrganizationsMapStore, useMapRefStore } from "../store.jsx";
import { margin_bottom, Form } from "../FindOrganizationsMap.module.css";
import MapDropdownList from "./MapDropdownList.jsx";

export default function MapInputField() {
    const {
        inputValue,
        setInputValue,
        setSuggestions,
        setShowSuggestions,
        getOrganizations,
        bransch,
        fairIsChecked,
    } = useFindOrganizationsMapStore();

    const { containerRef } = useMapRefStore();

    const handleOnChangeInput = (e) => {
        e.stopPropagation();
        setInputValue(e.target.value);

        // if (e.target.value.length < inputValue.length) {
        //     setShowSuggestions(false);
        //     return;
        // }

        setShowSuggestions(true);
        setSuggestions(e.target.value);
        e.preventDefault();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        // setExpandendResults(true);
        getOrganizations(bransch, inputValue, fairIsChecked);

        setShowSuggestions(false);
    };

    const handleFocus = () => {
        containerRef?.current.scrollIntoView({
            behavior: "smooth",
        });
    };

    return (
        <form onSubmit={handleSubmit} className={Form}>
            <InputField
                onFocus={handleFocus}
                placeholder="Sök län, ort, företagsnamn..."
                className={margin_bottom}
                type="text"
                icon="search"
                value={inputValue}
                onButtonSubmit={handleSubmit}
                onSubmit={handleSubmit}
                onChange={handleOnChangeInput}
                iconColor={
                    inputValue?.length < 2
                        ? "--neutral-greyscale-300"
                        : "--neutral-greyscale-600"
                }
            />
            <MapDropdownList />
        </form>
    );
}
